var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72 36.05C72 55.9605 55.8829 72.1 36 72.1C16.1171 72.1 0 55.9605 0 36.05C0 16.1395 16.1171 0 36 0C55.8829 0 72 16.1395 72 36.05Z",
    fill: "#FFA216"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36.0502C63 50.9831 50.9122 63.0877 36 63.0877C21.0878 63.0877 9 50.9831 9 36.0502C9 21.1173 21.0878 9.0127 36 9.0127C50.9122 9.0127 63 21.1173 63 36.0502Z",
    fill: "#FFA216"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2845 42.057L32.9845 28.767H37.9045L37.6045 42.057H33.2845ZM33.0745 49.167V44.427H37.8145V49.167H33.0745Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4e9382eece63ba7cd0ba5328b47a86e6.svg";
export { ForwardRef as ReactComponent };